<template>
<div>
  <transparentheaders ref="brother"></transparentheaders>
  <div class="box">
    <div class="registerbox">
      <el-form class="registercontent">
        <div class="userregister">注册用户</div>
        <el-form-item prop="property">
          <el-select v-model="propertyId" placeholder="选择属性" @change="changepropertyId">
            <el-option v-for="item in propertyList" :key="item.id" :label="item.name" :value="item.id">
              <!-- <span style="float: left">{{ item.name }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="industry">
          <el-select v-model="value1" multiple placeholder="选择行业" @change="changeindustryId">
            <el-option v-for="item in industryList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="region">
          <el-select v-model="value2" multiple placeholder="选择大区" @change="changeregionId">
            <el-option v-for="item in regionList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="phone">
          <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="tel1" placeholder="手机号码"></el-input>
        </el-form-item>
        <el-form-item prop="username">
          <el-input v-model="username" placeholder="昵称"></el-input>
        </el-form-item>

        <el-form-item prop="pwd">
          <el-input v-model="pwd" show-password placeholder="密码"></el-input>
        </el-form-item>

        <el-button type="primary" @click="

            messagechange()

          ">确认注册</el-button>
        <div class="greet">
          <span class="line"></span><span class="txt">客服电话:&nbsp; 021-66532456</span><span class="line"></span>
        </div>
      </el-form>
    </div>
  </div>
</div>
</template>

<script>
import {
  propertyList
} from "../api/api";
import {
  industryList
} from "../api/api";
import {
  regionList
} from "../api/api";
import {
  reg
} from "../api/api";
import transparentheaders from "../components/transparentheaders.vue"
export default {
  name: "register",
  data() {
    return {
      value1: "",
      value2: "",
      tel1: "", //手机号
      pwd: "", //密码
      username: "", //用户名
      msg: "", //弹出的消息
      propertyList: [], //属性列表
      industryList: [], //行业列表
      regionList: [], //大区列表
      propertyId: "", //属性id
      List1: [],
      List2: [],
      List3: []
    };
  },

  components: {
    transparentheaders,
  },
  mounted() {
    this.getpropertyList();
  },

  methods: {
    getpropertyList() {
      propertyList().then(res => {
        if (res.data.code == 200) {
          this.propertyList = res.data.result;
          if (res.data.result.length) {
            (this.propertyId = res.data.result[0].id),
            (this.List1 = [{
              propertyId: res.data.result[0].id
            }]);
            this.getindustryList();
            this.getregionList();
          }
        }
      });
    },
    getindustryList() {
      industryList({
        propertyId: this.propertyId
      }).then(res => {
        if (res.data.code == 200) {
          this.industryList = res.data.result;
        }
      });
    },
    getregionList() {
      regionList({
        propertyId: this.propertyId
      }).then(res => {
        if (res.data.code == 200) {
          this.regionList = res.data.result;
        }
      });
    },
    postreg() {},
    changepropertyId(e) {
      this.propertyId = e;
      this.List1 = [{
        propertyId: e
      }];
      this.List2 = [];
      this.List3 = [];
      this.industryList = [];
      this.regionList = [];
      this.getindustryList();
      this.getregionList();
      this.value1 = "";
      this.value2 = "";
    },
    changeindustryId(arr) {
      this.List2 = arr.map(e => ({
          propertyId: this.propertyId,
          industryId: e
      }))
      // let data;
      // arr.forEach(e => {
      //   data = {
      //     propertyId: this.propertyId,
      //     industryId: e
      //   };
      // });
      // this.List2.push(data);
    },
    changeregionId(arr) {
       this.List3 = arr.map(e => ({
          propertyId: this.propertyId,
          bigRegionId: e
      }))
      // let data;
      // arr.forEach(e => {
      //   data = {
      //     propertyId: this.propertyId,
      //     bigRegionId: e
      //   };
      // });
      // this.List3.push(data);
    },

    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {
        if (this.msg === "注册成功") {
          this.$router.push({
            path: "/"
          });
        }
      });
    },
    messagechange() {
      var phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则;
      var passwordreg = /^[a-zA-Z\d]{6,16}$/;

      if (!passwordreg.test(this.pwd)) {
        this.msg = "密码应为6-16位字符";
        this.open();
      }
      if (this.username === "") {
        this.msg = "请输入昵称";
        this.open();
      }

      if (!phoneReg.test(this.tel1)) {
        this.msg = "请输入正确的11位手机号";
        this.open();
      }
      if (this.value2.length === 0) {
        this.msg = "请选择大区";
        this.open();
      }

      if (
        !(
          this.value1.length === 0 ||
          !phoneReg.test(this.tel1) ||
          !passwordreg.test(this.pwd) ||
          this.username === "" ||
          this.propertyId === "" ||
          this.value2.length === 0
        )
      ) {
        this.register();
        this.msg = "注册成功";

      }

      // let data = this.msg;
      // data = "请输入电话号码"
      // console.log(data);
    },

    register() {
      let data = {
        appuserProperties: this.List1,
        appuserIndustryList: this.List2,
        appuserRegionList: this.List3,
        backup1: "",
        backup2: "pc",
        tel1: this.tel1,
        mininame: this.username,
        username: this.tel1,
        pwd: this.pwd
      };
      console.log(data);
      reg(data).then(res => {
        if (res.data.code == 200) {
          console.log(res.data.result);
          console.log(res.data);
          setTimeout(() => {
            //需要延迟的代码 :3秒后延迟跳转到首页，可以加提示什么的
            this.$router.push({
              path: "/"
            });
            //延迟时间：3秒
          }, 3000);
          this.open();
          const token = res.data.result.token;
          const userinfo = res.data.result.userInfo;

          // var jsontoken = JSON.stringify(token);// 转成JSON格式
          // var token2 = $.parseJSON(jsontoken);// 转成JSON对象
          var userinfo_Data = JSON.stringify(userinfo);
          this.$store.commit("set_token", token);
          this.$store.commit("setUserInfo", userinfo_Data);
        }
        if (res.data.code == 0) {
          console.log(res.data.message);
          this.msg = res.data.message;
          this.open()
        }
        if (res.data.code == 500) {
          console.log(res.data.message);
          this.msg = res.data.message;
          this.open()
        }
      });

    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100vh
}

.userregister {
  padding: 5px;

  margin-bottom: 15px;
  font-size: 36px;
  font-family: "SourceHanSansCN";
  color: rgb(56, 56, 56);
  line-height: 1.5;
}

.registerbox {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-image: url(../assets/images/login.png);
  z-index: -1;
}

.registercontent {
  padding: 50px 70px 70px 70px;
  // width: 473px;
  // height: 590px;
  position: fixed;
  top: 20%;
  right: 20%;
  z-index: 1;
  // border: solid 1px red;
  margin-right: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: white;
  box-shadow: 0px 0px 20px 0px rgba(10, 108, 255, 0.2);
  border-radius: 20px;
}

.el-select {
  width: 275px;
  margin-bottom: 10px;

}

>>>.el-icon-arrow-up:before {
  margin-left: 10px;
  content: url(../assets/images/arrow.png);
}

.el-input {
  width: 275px;
  height: 40px;
  margin-bottom: 10px;
}

.el-button {
  width: 275px;
  height: 50px;
  margin-top: 7px;
  color: #fff;
  background-color: rgb(10, 108, 255);
  border-color: rgb(10, 108, 255);
  border-radius: 10px;
  font-size: 18px;
}

>>>.el-input__inner {
  border-radius: 10px;
}

.white {
  width: 476px;
  height: 590px;
  position: fixed;
  top: 23%;
  right: 17%;
  z-index: 0;
}

.greet {
  font-size: 15px;
  font-family: "Microsoft YaHei";
  color: rgb(163, 163, 163);
  line-height: 3.6;
  text-align: left;
  position: relative;
  height: 60px;
}

.greet .line {
  display: inline-block;
  width: 40px;
  border-top: 1px solid rgb(163, 163, 163);
}

.greet .txt {
  color: rgb(163, 163, 163);
  vertical-align: -4px;
  margin: 10px;
}

.el-form-item {
  margin-bottom: 10px;

}

>>>.el-message-box__content {
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/registerbackground.vue